import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Image from 'components/Image';

import { sendEvent } from 'lib/gtag';

const SponsorAd = forwardRef(({ ad, gaEventCategory, position }, ref) => {
  const onClick = () => {
    sendEvent({
      action: `blog_ads_banner_${position}`,
      category: gaEventCategory,
    });
  };

  return (
    <a
      ref={ref}
      href={ad.url}
      rel="noopener noreferrer"
      target="_blank"
      onClick={onClick}
    >
      <Image
        alt={ad.description}
        className="rounded-2"
        height={250}
        src={ad.image}
        width={300}
      />
    </a>
  );
});

SponsorAd.displayName = 'SponsorAd';

SponsorAd.propTypes = {
  ad: PropTypes.shape({
    description: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    image: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    visibility: PropTypes.string.isRequired,
  }).isRequired,
  gaEventCategory: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
};

export default SponsorAd;
